<div class="col-12">
  <div class="border-bottom-1 surface-border">
    <p class="text-sm m-0 mb-2">
      Let's get you set up to receive job offers in 3 minutes
    </p>
    <p class="text-sm m-0 mb-2">
      Complete your profile to start receiving personalized opportunities from top employers
    </p>
    <div class="flex flex-column gap-2 mb-2">
        <p-progressBar [style]="{ height: '4px' }" [value]="profileStrengthValue" />
        <span class="text-xs">Your profile is {{profileStrengthValue}}% completed.</span>
    </div>
    <div class="flex flex-row align-items-start gap-3 mt-4 mb-4">
      <p-button (click)="editProfile()" label="start my profile"></p-button>
      <p-button (click)="accountSettings()" label="account settings"></p-button>
    </div>    
  </div>
</div>
